import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { User } from '../models/user';

@Injectable()
export class UserService {
  user = new User;

  // user$: Observable<User>;
  // private userSubject: Subject<User>;

  constructor() {
    // this.userSubject = new Subject<User>();
    // this.user$ = this.userSubject.asObservable();
  }

  setAuthentication(response) {
    localStorage.setItem('bearer', response.access_token);
    localStorage.setItem('roleId', response.roles);
    localStorage.setItem('userId', response.userID);
    localStorage.setItem('expiresIn', response.expires_in);
    localStorage.setItem('loginTime', Date.now().toString());
  }

  setUserInformation(response) {
    //console.log('user info', response);
    localStorage.setItem('firstName', response.FirstName);
    localStorage.setItem('lastName', response.LastName);
    localStorage.setItem('phone', response.Phone);
    localStorage.setItem('email', response.Email);
    localStorage.setItem('username', response.Username);
    localStorage.setItem('profilePhotoPath', response.ProfilePhotoPath);
    localStorage.setItem('isPaying', (response.IsPaying) ? response.IsPaying : false);
  }

  getUserInformation() {
    this.user.firstName = localStorage.getItem('firstName');
    this.user.lastName = localStorage.getItem('lastName');
    this.user.phone = localStorage.getItem('phone');
    this.user.username = localStorage.getItem('username');
    this.user.email = localStorage.getItem('email');
    return this.user;
  }

  // remove() {
  //   this.selectedModal = {};
  // }

  // open() {
  //   this.selectedModal.open();
  // }

  // close() {
  //   this.selectedModal.close();
  // }    
}